import * as React from 'react'

const SvgPageFirstIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 10L15 3.75l.875.875L10.5 10l5.375 5.375-.875.875L8.75 10zM5 2.5h1.25v15H5v-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgPageFirstIcon
